import { actionsStyles } from "@dana/Overrides/Widgets/QuickOrder/QuickOrderActions";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

actionsStyles.addToListButton = mergeToNew(actionsStyles.addToListButton, {
    variant: "secondary",
    css: css`
        padding: 8px 12px;
        min-width: 130px; 
    `
});

actionsStyles.addAllToCartButton = mergeToNew(actionsStyles.addAllToCartButton, {
    variant: "secondary",
    css: css`
        padding: 8px 12px;
        min-width: 130px; 
    `
});

actionsStyles.uploadOrderButton = mergeToNew(actionsStyles.uploadOrderButton, {
    css: css`
        padding: 8px 12px;
        min-width: 130px; 
    `
});
